import React, { useReducer } from 'react'
import ReportContext from './reportContext'
import ReportReducer from './reportReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    GET_ALL_REPORT_DISPLAY,
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
    GET_ALL_REPORT_TEMPLATES,
} from './reportTypes'
const FileSaver = require('file-saver')

const ReportState = (props) => {
    const initialState = {
        responseStatus: null,
        reports_data: null,
        report_templates: null,
    }

    const [state, dispatch] = useReducer(ReportReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllReportDisplay = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'display', formData, '', 'report'),
            ])
            const from = 'ReportDisplay'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_REPORT_DISPLAY,
                    payload: res.data.data.responseData,
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getXLSXFile = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'export_xlsx', formData, '', 'report'),
            ])
            const from = 'export_xlsx'
            if (res.data.status === 'success') {
                resp.commonResponse(res.data, from)
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllReportDownload = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'download', formData, '', 'report'),
            ])
            const from = 'ReportDisplay'
            if (res.data.status === 'success') {
                if (formData?.download_xlsx) {
                    setTimeout(() => {
                        window.open(res.data.data.responseData.filename)
                    }, 800)
                } else {
                    const csvData = new Blob(
                        [res.data.data.responseData.records],
                        {
                            type: 'text/csv;charset=utf-8;',
                        }
                    )
                    if (res.data.data.responseData.xl_voucher) {
                        console.log('inside file')
                        FileSaver.saveAs(res.data.data.responseData.filename)
                    } else {
                        FileSaver.saveAs(
                            csvData,
                            res.data.data.responseData.filename
                        )
                    }
                }
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllExportDownload = async (formData, topHeading) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'export', formData, '', 'report'),
            ])
            const from = 'ReportDisplay'
            if (res.data.status === 'success') {
                if (formData?.download_xlsx) {
                    setTimeout(() => {
                        window.open(res.data.data.responseData.filename)
                    }, 800)
                } else {
                    const csvData = new Blob(
                        [res.data.data.responseData.records],
                        {
                            type: 'text/csv;charset=utf-8;',
                        }
                    )
                    FileSaver.saveAs(
                        csvData,
                        topHeading
                            ? topHeading
                            : res.data.data.responseData.filename
                    )
                }
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllSampleDownload = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'sample', formData, '', 'report'),
            ])
            const from = 'SampleDisplay'
            if (res.data.status === 'success') {
                const csvData = new Blob([res.data.data.responseData.records], {
                    type: 'text/csv;charset=utf-8;',
                })
                FileSaver.saveAs(csvData, res.data.data.responseData.filename)
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const reportTemplateAction = async (formData, from = 'createTemplate') => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'templateAction', formData, '', 'report'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getAllReportTemplates = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAllTemplates', formData, '', 'report'),
            ])
            const from = 'ReportDisplay'

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_REPORT_TEMPLATES,
                    payload: res.data.data?.records
                        ? res.data.data?.records
                        : [],
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const deleteReportTemplate = async (formData) => {
        try {
            const from = 'deleteReportTemplate'
            const [res] = await Promise.all([
                apiCall('post', 'deleteReportTemplate', formData, '', 'report'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })
    return (
        <ReportContext.Provider
            value={{
                reports_data: state.reports_data,
                report_templates: state.report_templates,
                responseStatus: state.responseStatus,
                clearResponse,
                getAllReportDisplay,
                getAllReportDownload,
                getAllExportDownload,
                getAllSampleDownload,
                getXLSXFile,
                reportTemplateAction,
                getAllReportTemplates,
                deleteReportTemplate,
            }}
        >
            {props.children}
        </ReportContext.Provider>
    )
}

export default ReportState
